export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14873.70752e14.jpg";